import SelectedActions from './selected-actions';

export default SelectedActions;